// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sk-spinner {\n  color: #333;\n}\n\n.sk-spinner > div {\n  background-color: currentColor;\n}\n", ""]);
// Exports
module.exports = exports;
